import React, { useState } from "react";
import { useErrorHandler } from "../../../../hooks";
import { InputLabel, MenuItem, Select } from "@material-ui/core";

import {
    Button,
    DialogActions,
    Divider,
} from "@material-ui/core";

import DialogTitle from "../../../../components/dialog-title";
import pageBuilderRowService from "../../../../services/page-builder-row.service";


export default function ChangeSort({ close, allData, data }) {

    const [indexRow, setIndexRow] = useState(data.order)

    const errorHandler = useErrorHandler();

    const handleSubmit = async () => {
        let aa = allData
            .filter(item => item.id !== data.id)
            .sort((a, b) => a.order - b.order);

        let newSort = [
            ...aa.slice(0, indexRow - 1),
            data,
            ...aa.slice(indexRow - 1),
        ];

        let op = await pageBuilderRowService.updatePageBuilderRowSort(data.pageId, { rowIds: newSort.map(item => item.id) });

        const { error } = op;
        if (error) return errorHandler(error);

        close(true);
    };

    return (
        <>
            <DialogTitle onClose={close}>
                تغییر ردیف
            </DialogTitle>
            <Divider />

            <div className="m-2">
                <InputLabel id="label">ردیف</InputLabel>
                <Select
                    labelId="label"
                    id="select"
                    value={indexRow}
                    margin="normal"
                    variant="outlined"
                    fullWidth={true}
                    onChange={(e) => setIndexRow(e.target.value)}
                >
                    {
                        Array(allData.length).fill(1).map((item, index) => (
                            <MenuItem value={index + 1}>{index + 1}</MenuItem>
                        ))
                    }
                </Select>
            </div>
            <DialogActions>
                <Button onClick={close} color="primary">
                    لغو
                </Button>
                <Button
                    type="submit"
                    variant="contained"
                    color="primary"
                    onClick={handleSubmit}
                >
                    ذخیره
                </Button>
            </DialogActions>
        </>
    );
}
